import { useState } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Card, Field } from "@/components/ranger/PageHeader";
import { BTN_PRIMARY } from "@/pages/Servers";
import { api, errMsg } from "@/lib/api";

const EMPTY = { current_password: "", new_password: "", confirm: "" };
const cls = "border-[#1E2D4A] bg-[#050811]";

export const ChangePassword = () => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const weak = f.new_password && !(f.new_password.length >= 10 && /[a-z]/i.test(f.new_password) && /\d/.test(f.new_password));
  const mismatch = f.confirm && f.confirm !== f.new_password;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password }); toast.success("Password changed. Other sessions were signed out."); setF(EMPTY); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Card title="Owner password" icon={Lock} testId="change-password-card" className="mb-5">
      <form onSubmit={submit} className="grid gap-4 sm:grid-cols-3">
        <Field label="Current password"><Input data-testid="change-password-current" type="password" autoComplete="current-password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} className={cls} /></Field>
        <Field label="New password" hint="10+ characters, letters and numbers">{<Input data-testid="change-password-new" type="password" autoComplete="new-password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} className={cls} />}</Field>
        <Field label="Confirm new password"><Input data-testid="change-password-confirm" type="password" autoComplete="new-password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className={cls} /></Field>
        <div className="flex items-center gap-3 sm:col-span-3">
          <button data-testid="change-password-submit" disabled={busy || !f.current_password || !f.new_password || weak || mismatch} className={BTN_PRIMARY}>{busy ? "Saving…" : "Change password"}</button>
          {(weak || mismatch) && <span data-testid="change-password-error" className="text-xs text-red-400">{mismatch ? "Passwords don't match" : "Use 10+ characters with letters and numbers"}</span>}
        </div>
      </form>
      <p className="mt-3 text-xs text-slate-500">Takes effect immediately, no redeploy. Once changed here, the password in server settings is no longer used.</p>
    </Card>
  );
};
